export default "__VITE_ASSET__BOEW0iei__"